<template>
  <div class="ApplicationSaveCancel">
    <div v-if="!isReview()" class="bar">
      <span class="sr-only" role="status">{{ savedStatus }}</span>
      <button
        class="primary"
        type="submit"
        :disabled="blockNavigation"
        @click="save('next')"
      >
        Save &amp; continue to next section
      </button>
    </div>

    <div v-if="isReview()" class="bar">
      <button
        class="primary"
        type="button"
        :disabled="blockNavigation || !canSubmit"
        @click="submit"
      >
        Submit application
      </button>
    </div>
  </div>
</template>

<script>
import { CHOOSE_DATE } from '@/constants'

import endPoint from '@/store/endPoint'
import UTILS from '@/store/utils'

import { auth } from '@/store/fixture'

// import helpers
import objectToPrint from '@/store/helper/objectToPrint'
import arrayValueToBoolean from '@/store/helper/arrayValueToBoolean'

import droplistData from '@/applicationDefinition/droplistData/index'

import fieldsMixin from '@/components/mixins/fieldsMixin'
import { API_ERROR_SUBTYPES } from '@/constants'

import {
  purgeEmptyFromObject,
  purgeHiddenFromFields,
  purgeMetaFromObject,
  clone
} from '@/../src/applicationDefinition/helper'

import { mapGetters } from 'vuex'

export default {
  name: 'ApplicationSaveCancel',
  mixins: [fieldsMixin],
  data() {
    return {
      savedStatus: null
    }
  },
  computed: {
    canSubmit() {
      return !!this.$store.state.application.clientName_1 //TODO - AM need to enable this
      //return true
    },
    application() {
      return this.$store.state.application || {}
    },
    ...mapGetters(['blockNavigation'])
  },
  methods: {
    isReview() {
      try {
        return this.$store.state.application.meta.sectionExpandedId === 'review'
      } catch (e) {
        return false
      }
    },
    convertSupportingDocsForPDF(
      supportingDocumentsData,
      supportingDocumentFields
    ) {
      return supportingDocumentFields.map(field => {
        const label = this.getVHtmlLabel(field, this.application)
        const data =
          (supportingDocumentsData &&
            supportingDocumentsData[field.category]) ||
          {}
        return { ...data, label }
      })
    },


    save(type) {
      const sectionExpandedId = this.$store.state.application.meta
        .sectionExpandedId
      const section = this.$store.state.sections.find(
        item => item.id === sectionExpandedId
      )

      this.$store.commit('set', ['auth.isUserActive', true])
      this.$store.commit('set', ['auth.isUserActiveTime', new Date().getTime()])
        // section can have errors when saving to database
        this.$store
          .dispatch('saveApplicationSection', { section, type })
          .catch(() => {
            this.$store.dispatch('set', ['saveStatus', null])
            this.$store.dispatch('set', [
              'error',
              new Error('Error when saving: Could not reach server')
            ])

            this.$router.history.push('/error')
          })
          .finally(() => this.$store.dispatch('hideSpinner'))

        this.$scrollTo('#app', 1)

        if (type === 'next') {
          setTimeout(() => {
            this.savedStatus = null
            setTimeout(() => {
              this.savedStatus = 'Saved'
            }, 10)
          }, 10)

          const curSectionIdx = this.$store.state.sections.findIndex(
            item => item.id === sectionExpandedId
          )
          const nextSectionId = this.$store.state.sections[curSectionIdx + 1].id

          this.$store.commit('set', ['auth.isUserActive', true])
          this.$store.commit('set', [
            'auth.isUserActiveTime',
            new Date().getTime()
          ])

        }
        let pdfData = this.$store.state.application
        if (pdfData && pdfData.meta.hasAttemptToSubmit) {
          this.$store.dispatch('buildAlerts')
        }
        this.$store.dispatch('buildCounters')
    },
    submit() {
      // validate form first and stop if errors
      if (this.$store.state.application) {
        this.$store.dispatch('set', [
          'application.meta.hasAttemptToSubmit',
          true
        ])
      }

      this.$store.dispatch('buildAlerts')
      this.$store.dispatch('buildCounters')

      if (this.$store.state.alerts && this.$store.state.alerts.length > 0) {
        let firstSectionWithAlerts = this.$store.state.alerts.map(
          a => a.section.id
        )[0]
        this.$store.dispatch('setFocus', firstSectionWithAlerts)
        return false
      }

      // JW: pdfData contains application data for rendering the confirmation
      // pdf. It receives additional "print" values that the pdf uses to show
      // looked-up values (instead of their underlying codes). This design
      // is a big maintenance issue and will hopefully be replaced soon.
      let pdfData = purgeEmptyFromObject(this.$store.state.application, true)

      // purge hidden fields
      this.$store.state.sections.map(
        section =>
          (pdfData = purgeHiddenFromFields(
            section.fields,
            pdfData,
            this.$store
          ))
      )

      // convert client ID to client name
      const clientName_1 = pdfData.client.firstName +
          ' ' +
          pdfData.client.lastName

      pdfData.clientName_1 = clientName_1

      let postData = clone(pdfData)

      // purge country name
     // if (postData.residentialAddress.countryName) {
      //  delete postData.residentialAddress.countryName
     // }

      // populate first name
      postData.client.firstName  =    postData.client.firstName

      

      // ### Supporting documents

      // Remove categories where includeFiles IS NOT true
      // AND convert categories where includeFiles IS true to just the files array
      if (postData.supportingDocuments) {
        postData.supportingDocuments = Object.entries(
          postData.supportingDocuments
        ).reduce((accumulator, [category, { includeFiles, files }]) => {
          if (includeFiles && files) {
            //Convert files to only include objectKey
            accumulator[category] = files.map(({ objectKey }) => ({
              objectKey
            }))
          }
          return accumulator
        }, {})
      }

      //Add labels defined in refData to pdfData and convert to array
      const supportingDocumentsSection3 = this.$store.state.sections.find(
        section => {
          return (section.id==='identityProof')
        }
      )

      const supportingDocumentsCategories3 =
        supportingDocumentsSection3.fields[1].panels

      pdfData.identityProof_1= pdfData.supportingDocuments

      pdfData.identityProof_1 = this.convertSupportingDocsForPDF(
        pdfData.identityProof_1,
        supportingDocumentsCategories3
      )

      // ### Review

           // purge meta from object
      postData = purgeMetaFromObject(postData)

     
      // ##### map text value for print
      pdfData = objectToPrint(pdfData)
     
      this.$store.dispatch('showSpinner')

      endPoint
        .submitApplication(this.$store.state.auth.idToken, postData, pdfData)
        .then(resp => {
          this.$store.dispatch('hideSpinner')

           var response = JSON.stringify(resp.data.body.applicationId);          

          // save application id in store 
          this.$store.commit('set', ['submittedApplicationId', response.replace(/\"/g, "")])

          // clear form data
          this.$store.commit('set', ['auth', auth])

          // direct to confirmation page
          this.$scrollTo('#app', 1)
          this.$router.history.push('/confirmation')
        })
        .catch(error => {
          this.$store.dispatch('hideSpinner')
          this.$store.dispatch('setAPIError', {
            error,
            fallbackCode: API_ERROR_SUBTYPES.submit
          })
          this.$router.history.push('/error')
        })
    },
    goto(type) {
      const section = this.$store.state.sections.find(
        item => item.id === this.$store.state.application.meta.sectionExpandedId
      )
      this.$store.dispatch('gotoApplicationSection', { section, type })
    }
  }
}
</script>

<style scoped lang="scss">
.ApplicationSaveCancel {
  width: 100%;
  text-align: right;
  padding: 0 $content-padding;
  font-size: 1.6rem;

  .bar {
    border-top: 2px solid $color-primary;
    padding: 0.75rem 0;
  }

  button {
    margin: 0 0 0 0.5rem;
    padding: 1rem 2rem;
    border: 0;
    min-width: 7rem;
  }
}
</style>
